"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
import { LitElement, html } from "lit";
import { property } from "lit/decorators.js";
import { STCComponentMixin } from "../../../common/mixins/stc_component_mixin";
export class CampaignCategoryComponent extends STCComponentMixin(LitElement) {
  constructor() {
    super(...arguments);
    this.campaigns = [];
  }
  render() {
    return html`
      <hi-tile class="campaignsLandingPageTile mbex" allow-toolbar>
        <h2 slot="title">${this.title}</h2>
        <div class="campaignsLandingPageTileItem">
          <p class="text-sz-l">${this.desc}</p>
        </div>
        ${this.campaigns.map((campaign) => html`
          <stc-campaign-item
            index-link="${campaign.indexLink}"
            index-aria-label="${campaign.indexAriaLabel}"
            title="${campaign.title}"
            desc="${campaign.desc}"
            new-link="${campaign.newLink}"
            new-aria-label="${campaign.newAriaLabel}"
          ></stc-campaign-item>
        `)}
      </hi-tile>
    `;
  }
}
__decorateClass([
  property({ type: String })
], CampaignCategoryComponent.prototype, "title", 2);
__decorateClass([
  property({ type: String })
], CampaignCategoryComponent.prototype, "desc", 2);
__decorateClass([
  property({ type: Object })
], CampaignCategoryComponent.prototype, "campaigns", 2);
customElements.define("stc-campaign-category", CampaignCategoryComponent);
